/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	type Action,
	type BoundActions,
	type HookFunction,
} from '@atlassian/react-sweet-state';
import { actions } from './getOnboardingTypeActions.tsx';
import type { State } from './OnboardingTypeResponse.types.tsx';

type Actions = typeof actions;

export const initialState = {
	projectId: undefined,
	data: undefined,
	error: undefined,
	isLoading: false,
} as const;

const Store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'JSMOnboardingType',
});

export const useJsmOnboardingType: HookFunction<
	State,
	BoundActions<
		State,
		{
			readonly fetchOnboardingType: (
				projectId: number | undefined,
				projectType: string | undefined, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
			) => Action<State, any>;
		}
	>,
	void
> = createHook(Store);
